<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex-grow">
                <div class="vx-col md:w-1/6 sm:w-auto mr-4" style="display: inline-block">
                    <label class="vs-input--label">Chi nhánh</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions"/>
                </div>
                <div class="vx-col md:w-1/5 sm:w-auto mr-4" style="display: inline-block">
                    <label class="vs-input--label">Nhân viên</label>
                    <v-select class="" v-model="selectedEmployee" :clearable="false" :options="employeeOptions"/>
                </div>
                <div class="vx-col md:w-1/6 sm:w-auto mr-4" style="display: inline-block">
                    <label class="vs-input--label">Bắt đầu</label>
                    <datepicker :format="'dd/MM/yyyy'" v-model="start"
                                data-vv-validate-on="input" name="start"></datepicker>
                    <span class="text-danger text-sm">{{ errors.first('start') }}</span>
                </div>
                <div class="vx-col md:w-1/6 sm:w-auto mr-4" style="display: inline-block">
                    <label class="vs-input--label">Kết thúc</label>
                    <datepicker :format="'dd/MM/yyyy'" v-model="end"
                                data-vv-validate-on="input" name="end"></datepicker>
                    <span class="text-danger text-sm">{{ errors.first('end') }}</span>
                </div>
                <div class="vx-col md:w-1/8 sm:w-auto mr-4" style="display: inline-block">
                    <vs-button class="ml-auto mt-2" @click="filter" :disabled="!validateForm">Lọc</vs-button>
                </div>

            </div>
            <div class="flex flex-wrap items-center mt-5">
                <div class="flex-grow">
                    <vs-button
                        @click="addDailyWork"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-settings">
                        Thêm công việc
                    </vs-button>

                </div>

                <!-- ITEMS PER PAGE -->
                <Pagination
                    :itemList="workShiftData"
                    :currentPage="currentPage"
                    :paginationPageSize="paginationPageSize"
                    :gridApi="gridApi"
                />

                <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                          v-model="searchQuery"
                          @input="updateSearchQuery" placeholder="Tìm kiếm..."/>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :components="components"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :autoGroupColumnDef="autoGroupColumnDef"
                         :rowData="workShiftData"
                         :animateRows="true"
                         :pagination="true"
                         :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                         :paginationPageSize="paginationPageSize"
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                :max="maxPageNumbers"
                v-model="currentPage"/>
        </div>
    </div>
</template>


<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import authConfig from '@/../auth_config.json';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import Pagination from "../../ui-elements/Pagination.vue"

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        Datepicker,
        CellRendererActions,
        Pagination
    },
    data() {
        return {
            autoGroupColumnDef: null,
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'Mã nhân viên',
                    field: 'employeeCode',
                    width: 140
                },
                {
                    headerName: 'Tên nhân viên',
                    field: 'fullName',
                    width: 160
                },
                {
                    headerName: 'Khu vực',
                    field: 'areaName',
                    width: 200,
                },
                {
                    headerName: 'Công việc',
                    field: 'name',
                    width: 150,
                },
                {
                    headerName: 'Ngày',
                    field: 'displayWorkStartAt',
                    width: 110,
                },
                {
                    headerName: 'Kết quả',
                    field: 'displayStatus',
                    width: 130,
                },
                {
                    headerName: 'Actions',
                    field: 'actions',
                    width: 120,
                    cellRendererFramework: 'CellRendererActions',
                }
            ],
            // Cell Renderer Components
            components: {
                CellRendererActions
            },
            employeeData: [],
            workShiftData: [],
            organizationBranchOptions: [],
            employeeOptions: [
                {value: null, label: 'Tất cả'}
            ],
            selectedOrganizationBranchValue: null,
            selectedEmployeeValue: null,
            start: moment().format("YYYY/MM/DD"),
            end: moment().format("YYYY/MM/DD")
        }
    },
    created() {
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateEmployee'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_EMPLOYEE', false);
            }
        }
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj.value
                this.loadEmployee()
            }
        },
        selectedEmployee: {
            get() {
                return {
                    label: this.employeeString(this.selectedEmployeeValue),
                    value: this.selectedEmployeeValue
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj.value
            }
        }
    },
    methods: {
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },
        addDailyWork() {
            this.$router.push(`/user/add-daily-work?branch_id=${this.selectedOrganizationBranchValue}`);
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || 'xác định';
        },
        employeeString(id) {
            let employee = this.employeeOptions.find(x => x.value === id);
            return (employee && employee.label) || 'Chưa xác định';
        },
        addEmployee() {
        },
        validateForm() {
            return !this.errors.any()
        },
        filter() {
            let searchInfo = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployee.value ? [this.selectedEmployee.value] : null,
                start: moment(this.start).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                end: moment(this.end).set({hour: 23, minute: 59, second: 59, millisecond: 59})
            }
            this.$crm.post('/daily-work/employee/find-daily-work', searchInfo).then((response) => {
                let workShiftData = response.data.sort((item1, item2) => {
                    if (moment(item1.date) > moment(item2.date)) return 1;
                    if (moment(item1.date) < moment(item2.date)) return -1;
                    // return item1.employeeCode > item2.employeeCode ? 1 : -1
                })
                this.workShiftData = workShiftData.map(item => {
                    item.displayGroupName = item.groupName + " - " + item.workShiftName;
                    item.displayWorkStartAt = moment(item.workStartAt).format("DD/MM/YYYY");
                    item.displayUpdateStatusAt = item.updateStatusAt ? moment(item.updateStatusAt).format("HH:mm") : "";
                    item.displayStatus = ((status) => {
                        if (status == 0) return "Đang chờ"
                        if (status == 1) return "Đang làm"
                        if (status == 2) return "Đã hoàn thành"
                        if (status == 3) return "Hủy bỏ"
                    })(item.status);
                    return item;
                })
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }).finally(() => {
                this.gridApi.sizeColumnsToFit();
            });
        },
        exportFile() {
            let searchInfo = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployee.value,
                start: moment(this.start).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                end: moment(this.end).set({hour: 23, minute: 59, second: 59, millisecond: 59})
            };

            this.$vs.loading();
            this.$crm.post('/time-keeping/create', searchInfo).then((response) => {
                this.$vs.loading.close();
                window.open(authConfig.crmDomain + "file/" + response.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
            if (branchList.length == 0) {
                return this.$vs.notify({
                    text: 'Hiện tại không tồn tại chi nhánh nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.map(item => {
                return {value: item.id, label: item.organizationBranchName}
            })
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            this.filter()
        },
        loadEmployee() {
            if (!this.selectedOrganizationBranchValue) return;

            this.$vs.loading();
            this.$crm.post('/employee/find-by-organization-branch/' + this.selectedOrganizationBranchValue).then((response) => {
                this.employeeData = response.data;
                this.employeeOptions = response.data.map(item => {
                    return {
                        value: item.employeeId,
                        label: item.employeeCode + " " + item.fullName
                    }
                });
                this.employeeOptions.unshift({value: null, label: 'Tất cả'})
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>

</style>
